export default __webpack_public_path__ + "static/media/Shortee-1920.ddcf0843.webp";